import React, { useCallback } from 'react';
/** REDUX */
/** APOLLO */
import { useMutation, useApolloClient } from '@apollo/client';
import triggerScheduleMutation from '../../apollo/triggerScheduleMutation';
/** COMPONENTS */
/** UTILS */
import {
  ITriggerScheduleMutation,
  ITriggerScheduleMutationVariables,
  ScheduleType,
} from '../../../../utils/apollo/graphqlSchema';
import { selectModalData } from '../../../../redux/selectors/modal';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { closeModal } from '../../../../redux/slices/modal';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import printGraphqlErrors from '../../../../utils/apollo/printGraphqlErrors';
import SEARCH_SCHEDULES from '../../apollo/SEARCH_SCHEDULES';
import toastMessage from '../../../../utils/toastMessage';

interface IProps {
  type: ScheduleType;
}

export default ({ type }: IProps) => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const currentSchedule = useAppSelector(selectModalData);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const onScheduleTriggerCompleted = useCallback(
    ({ triggerSchedule }: ITriggerScheduleMutation) => {
      const { errors } = triggerSchedule;

      if (printGraphqlErrors(errors)) {
        return;
      }

      toastMessage({
        message: `${currentSchedule.name} has been triggered.`,
        type: 'info',
      });

      // refetch all cohort schedules to keep dictionary up to date with the new schedule
      client.refetchQueries({
        include: [SEARCH_SCHEDULES],
      });

      handleClose();
    },
    [client, currentSchedule.name, handleClose],
  );

  /* Update schedule mutation configuration */
  const [triggerSchedule, { loading }] = useMutation<
    ITriggerScheduleMutation,
    ITriggerScheduleMutationVariables
  >(triggerScheduleMutation, {
    variables: {
      id: currentSchedule.id,
    },
    onCompleted: onScheduleTriggerCompleted,
  });

  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={triggerSchedule}
      header={currentSchedule.name}
      confirmActionLabel={'Execute'}
      disabled={loading}
      modalType="primary"
      trackContext="schedules"
      trackConfirmAction="execute - confirm"
      trackCancelAction="execute - cancel"
    >
      {type === ScheduleType.BrazeCohortImport
        ? 'Do you want to execute this cohort import schedule now: '
        : 'Do you want to execute '}
      <strong>{currentSchedule.name}</strong>?
    </ConfirmationModal>
  );
};
